// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { viewSelectStyles } from "@eisinc/Overrides/Widgets/ProductList/ProductListViewSelect";
import Grid from "@eisinc/XDL/Icons/Grid";
import List from "@eisinc/XDL/Icons/List";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { css } from "styled-components";

viewSelectStyles.wrapper = {
    css: css`
        display: flex;
        gap: 8px;
        align-items: center;
    `,
};

viewSelectStyles.listViewClickable = viewSelectStyles.gridViewClickable = {};

viewSelectStyles.gridViewIcon = { src: Grid, ...{ width: 27, height: 19 } };

viewSelectStyles.listViewIcon = { src: List, ...{ width: 23, height: 16 } };

viewSelectStyles.viewLabel = {
    ...fontConfig.singleLineSmall,
};
